import { render, staticRenderFns } from "./partsManager.vue?vue&type=template&id=4f19a4fa&scoped=true"
import script from "./partsManager.vue?vue&type=script&lang=js"
export * from "./partsManager.vue?vue&type=script&lang=js"
import style0 from "./partsManager.vue?vue&type=style&index=0&id=4f19a4fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f19a4fa",
  null
  
)

export default component.exports